import { envType } from '../common/types';

import { PROD_PUBLIC_PATH, STAGING_PUBLIC_PATH } from './constants';

export const NOT_ATLASSIAN_USER_ERROR = 'Not an Atlassian user';
const isStaging = process.env.PUBLIC_PATH === STAGING_PUBLIC_PATH;
const isProd = process.env.PUBLIC_PATH === PROD_PUBLIC_PATH;

export const getEnvType = (): envType => {
	if (isStaging) {
		return envType.STAGING;
	}
	if (isProd) {
		return envType.PROD;
	}
	return envType.LOCAL;
};

export const getHostname = () => {
	return getEnvType() === envType.LOCAL
		? process.env.REMOTE_DOMAIN || ''
		: window.location.hostname;
};
